import React from "react";
import {
  Sheet,
  SheetContent,
} from "@/components/ui/sheet";

interface SheetProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  hasHeader?: boolean;
}

export default function CustomSheet({ onClose, open, children }: SheetProps) {
  return (
    <Sheet
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <SheetContent className="md:w-[504px] w-full p-0 overflow-y-auto">
        {children}
      </SheetContent>
    </Sheet>
  );
}